(() => {
  'use strict';
  const components = new Map();
  function init(root = document) {
    const footer = document.querySelector('.amua-footer');
    if (footer && !document.getElementById('amua-contact')) {
      const anchor = document.createElement('span');
      anchor.id = 'amua-contact';
      footer.prepend(anchor);
    }
    root.querySelectorAll('[data-amua-menu-component]').forEach(component => {
      if (components.has(component)) return;
      const overlay = component.querySelector('[data-amua-menu-overlay]');
      const panel = component.querySelector('.amua-menu-panel');
      const toggle = component.querySelector('[data-amua-menu-open]');
      if (!overlay || !panel || !toggle) return;
      let previousFocus = null, previousOverflow = '', inertState = [];
      const close = (restoreFocus = true) => {
        if (overlay.hidden) return;
        overlay.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        inertState.forEach(([node, inert]) => { if (node.isConnected) node.inert = inert; });
        inertState = [];
        document.body.style.overflow = previousOverflow;
        if (restoreFocus && previousFocus?.isConnected) previousFocus.focus();
      };
      const open = () => {
        if (!overlay.hidden) return;
        for (const other of components.values()) other.close(false);
        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;
        overlay.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        inertState = [...document.querySelectorAll('#MainContent,.amua-footer,.amua-announcement,.amua-header')].filter(node => !node.contains(overlay)).map(node => [node, node.inert]);
        inertState.forEach(([node]) => { node.inert = true; });
        panel.querySelector('.amua-menu-close')?.focus();
      };
      components.set(component, { component, overlay, panel, toggle, open, close });
    });
  }
  document.addEventListener('click', event => {
    const component = event.target.closest('[data-amua-menu-component]');
    const state = components.get(component);
    if (!state) return;
    if (event.target.closest('[data-amua-menu-open]')) {
      event.preventDefault();
      if (state.overlay.hidden) state.open(); else state.close();
    } else if (event.target.closest('[data-amua-menu-close]')) {
      event.preventDefault(); state.close();
    } else if (event.target.closest('[data-amua-menu-link]')) {
      state.close(false);
    } else if (event.target.closest('.amua-open-cart')) {
      state.close(false);
    }
  }, true);
  document.addEventListener('keydown', event => {
    const state = [...components.values()].find(item => !item.overlay.hidden);
    if (!state) return;
    if (event.key === 'Escape') {
      event.preventDefault(); event.stopPropagation(); state.close();
    } else if (event.key === 'Tab') {
      const focusables = [...state.panel.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex="0"]')].filter(element => element.getClientRects().length);
      const first = focusables[0], last = focusables.at(-1);
      if (!first) { event.preventDefault(); state.panel.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !state.panel.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !state.panel.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [component, state] of components) {
      if (event.target.contains(component)) { state.close(false); components.delete(component); }
    }
  });
  document.addEventListener('shopify:block:select', event => {
    const component = event.target.closest('[data-amua-menu-component]');
    const state = components.get(component);
    if (!state) return;
    if (state.panel.contains(event.target)) state.open();
    else if (event.target.closest('.amua-logo')) state.close(false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
